import * as React from "react";
import { Badge } from "react-bootstrap";

declare const window: any;

const formatDate = () => {
  const now = new Date();
  let formatted = now.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return formatted.replace("AM", "a.m.").replace("PM", "p.m.");
};

export default function VistaInmueblesContainer({
  theme,
  colors,
  setIsSideBar,
  isSideBar,
  isSelectedAptoView,
  isPortrait,
  icono,
  version,
  pisos,
  attributes,
  properties,
  setIsSelectedApto,
  cotizacion,
  selectedCotizacion,
  setSelectedCotizacion,
  setIsCotizacion,
  setGaleriaSelected,
  setSubMenuSelected,
  setOriginalGleriaSelected,
  setIsTooltipVistaInmueble,
  isTooltipVistaInmueble,
}: any) {
  const [alt, setAlt] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [touchStartY, setTouchStartY] = React.useState<number | null>(null);
  const [touchEndY, setTouchEndY] = React.useState<number | null>(null);
  const [isMinimized, setIsMinimized] = React.useState(false);

  function capitalizeWords(str: string): string {
    return str.toLowerCase().replace(/(^\w|\s\w)/g, (c) => c.toUpperCase());
  }

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEndY(e.touches[0].clientY);
  };

  const handleTouchEnd = () => {
    if (touchStartY === null || touchEndY === null) return;
    const diff = touchEndY - touchStartY;

    if (diff > 50) {
      // 👇 deslizó hacia abajo → minimizar
      setIsMinimized(true);
    } else if (diff < -50) {
      // 👆 deslizó hacia arriba → expandir
      setIsMinimized(false);
    }

    setTouchStartY(null);
    setTouchEndY(null);
  };

  // 🔹 Función para cambiar de inmueble
  const handleChangeProperty = (direction: any) => {
    const currentProperty = parseInt(isSelectedAptoView?.property);

    // Lista de todos los inmuebles ordenados
    const allProperties = properties
      ?.map((p: any) => parseInt(p.property))
      .sort((a: any, b: any) => a - b);

    if (!allProperties?.length) return;

    let newPropertyNumber =
      direction === "next" ? currentProperty + 1 : currentProperty - 1;

    // 🔁 Si pasa del último, vuelve al primero
    if (newPropertyNumber > allProperties[allProperties.length - 1])
      newPropertyNumber = allProperties[0];

    // 🔁 Si pasa antes del primero, vuelve al último
    if (newPropertyNumber < allProperties[0])
      newPropertyNumber = allProperties[allProperties.length - 1];

    const newProperty = properties.find(
      (p: any) => parseInt(p.property) === newPropertyNumber
    );

    if (!newProperty) return;

    setIsSelectedApto({
      ...newProperty,
      verts: isSelectedAptoView.verts,
    });
    setIsSideBar({
      ...newProperty,
      verts: isSelectedAptoView.verts,
    });
  };

  const currentFloor = parseInt(
    isSelectedAptoView?.values?.find((item: any) => item.type === "Piso/Nivel")
      ?.value
  );

  const handleSelectFloor = (piso: any) => {
    const newFloor = parseInt(piso?.value);
    const floorDiff = newFloor - currentFloor;
    const newPropertyNumber =
      parseInt(isSelectedAptoView?.property) + floorDiff * 100;

    const newProperty = properties?.find(
      (item: any) => item.property === newPropertyNumber.toString() && item?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value === isSelectedAptoView?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value
    );

    if (!newProperty) return;

    setIsSelectedApto({
      ...newProperty,
      verts: isSelectedAptoView.verts,
    });
    setIsSideBar({
      ...newProperty,
      verts: isSelectedAptoView.verts,
    });

    setIsOpen(false);
  };

  return !isPortrait ? (
    <div className={`vista-inmuebles-container ${theme}`}>
      <div
        className={`vista-inmuebles-sidebar ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
      >
        <div className="vista-inmuebles-sidebar-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(null);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        <div className="vista-inmuebles-sidebar-logo">
          <img
            src={
              version < "2.1.0"
                ? icono.icono
                : `${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net"
                  }${icono.icono}`
            }
            alt=""
          />
          <div className="vista-inmuebles-sidebar-title">VISTAS POR PISOS</div>
        </div>
        <div className="vista-inmuebles-sidebar-contenido">
          <div className="vista-inmuebles-sidebar-contenido-title">Pisos</div>
          <div className="vista-inmuebles-sidebar-contenido-valores">
            {pisos?.values?.map((piso: any, index: number) => {
              const currentFloor = parseInt(
                isSelectedAptoView?.values?.find(
                  (item: any) => item.type === "Piso/Nivel"
                )?.value
              );

              const newFloor = parseInt(piso?.value);
              const floorDiff = newFloor - currentFloor;

              const newPropertyNumber =
                parseInt(isSelectedAptoView?.property) + floorDiff * 100;

              const newProperty = properties?.find(
                (item: any) => item.property === newPropertyNumber.toString() && item?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value === isSelectedAptoView?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value
              );

              const isActive = currentFloor === newFloor;

              // Revisar galerías del newProperty primero; si no, fallback a isSelectedAptoView
              const galleriesToCheck =
                (Array.isArray(newProperty?.galleries) &&
                  newProperty.galleries) ||
                (Array.isArray(isSelectedAptoView?.galleries) &&
                  isSelectedAptoView.galleries) ||
                [];

              const hasVistaDeInmuebles = galleriesToCheck.some(
                (gallery: any) => gallery?.type === "Vistadeinmuebles"
              );

              const handleClick = () => {
                if (!hasVistaDeInmuebles || !newProperty) return; // Deshabilitado si no tiene galería
                setIsSelectedApto({
                  ...newProperty,
                  verts: isSelectedAptoView.verts,
                });
                setIsSideBar({
                  ...newProperty,
                  verts: isSelectedAptoView.verts,
                });
              };

              // Estilos condicionales
              const baseStyle: React.CSSProperties = {
                backgroundColor: isActive
                  ? colors?.main_buttons
                  : hasVistaDeInmuebles
                  ? undefined
                  : (theme === "Light" ? "rgba(225,225,225,0.8)" : "rgba(255,255,255,0.3)"), // gris suave para deshabilitados
                color: isActive
                  ? "#fff"
                  : hasVistaDeInmuebles ? "inherit" : (theme === "Light" ? "rgba(33,36,39,0.3)" : "rgba(255,255,255,0.5)"),
                cursor: hasVistaDeInmuebles ? "pointer" : "not-allowed",
                opacity: hasVistaDeInmuebles ? 1 : 0.5,
              };

              return (
                <div
                  key={index}
                  className="vista-inmuebles-sidebar-contenido-valor"
                  style={baseStyle}
                  onClick={handleClick}
                >
                  {piso?.value}
                </div>
              );
            })}
          </div>

          <div className="vista-inmuebles-sidebar-contenido-subir-bajar">
            {["Subir", "Bajar"].map((action, index) => {
              const currentFloor = parseInt(
                isSelectedAptoView?.values?.find(
                  (item: any) => item.type === "Piso/Nivel"
                )?.value
              );

              const handleClick = () => {
                let floorStep = action === "Subir" ? 1 : -1;
                let nextFloor = currentFloor + floorStep;
                let foundProperty = null;

                // Buscar el siguiente piso válido que tenga galería
                while (true) {
                  const floorDiff = nextFloor - currentFloor;
                  const newPropertyNumber =
                    parseInt(isSelectedAptoView?.property) + floorDiff * 100;

                  const candidate = properties?.find(
                    (item: any) =>
                      item.property === newPropertyNumber.toString() && item?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value === isSelectedAptoView?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value
                  );

                  if (!candidate) break; // No hay más pisos disponibles → salir

                  const galleriesToCheck =
                    (Array.isArray(candidate?.galleries) &&
                      candidate.galleries) ||
                    (Array.isArray(isSelectedAptoView?.galleries) &&
                      isSelectedAptoView.galleries) ||
                    [];

                  const hasVistaDeInmuebles = galleriesToCheck.some(
                    (gallery: any) => gallery?.type === "Vistadeinmuebles"
                  );

                  if (hasVistaDeInmuebles) {
                    foundProperty = candidate;
                    break; // Encontramos un piso válido → salimos del loop
                  }

                  nextFloor += floorStep; // seguimos buscando el siguiente
                }

                if (!foundProperty) return; // Ningún piso válido encontrado

                // Aplicar el cambio
                setIsSelectedApto({
                  ...foundProperty,
                  verts: isSelectedAptoView.verts,
                });
                setIsSideBar({
                  ...foundProperty,
                  verts: isSelectedAptoView.verts,
                });
              };

              return (
                <div
                  key={index}
                  className={`vista-inmuebles-sidebar-contenido-${
                    action === "Subir" ? "subir" : "bajar"
                  }`}
                  style={{ backgroundColor: colors?.main_buttons }}
                  onClick={handleClick}
                >
                  {action === "Subir" ? "▲ Subir" : "▼ Bajar"}
                </div>
              );
            })}
          </div>

          <div className="vista-inmuebles-sidebar-contenido-legal">
            Ver otros Inmuebles en este piso
          </div>
          <div className="vista-inmuebles-sidebar-contenido-inmueble">
            <div className="inmueble-header">
              <button
                className="arrow-btn"
                style={{ backgroundColor: colors?.main_buttons }}
                onClick={() => handleChangeProperty("prev")}
              >
                ←
              </button>

              <span className="inmueble-titulo">
                Inmueble
                <br />
                <strong>{isSelectedAptoView?.property}</strong>
              </span>

              <button
                className="arrow-btn"
                style={{ backgroundColor: colors?.main_buttons }}
                onClick={() => handleChangeProperty("next")}
              >
                →
              </button>
            </div>

            <div className="inmueble-estado">
              <Badge
                pill
                bg={
                  isSelectedAptoView?.availability === "DISPONIBLE"
                    ? "success"
                    : isSelectedAptoView?.availability === "RESERVADO"
                    ? "warning"
                    : isSelectedAptoView?.availability === "VENDIDO"
                    ? "danger"
                    : isSelectedAptoView?.availability === "NO DISPONIBLE"
                    ? "dark"
                    : "success"
                }
                className="inmueble-estado"
              >
                {capitalizeWords(isSelectedAptoView?.availability)}
              </Badge>
            </div>

            <div className="inmueble-info">
              <p>
                {
                  isSelectedAptoView?.values?.find(
                    (e: any) => e.hierarchicalLevel === "Jerarquico #2"
                  )?.value
                }
                {isSelectedAptoView?.values?.find(
                  (e: any) => e.hierarchicalLevel === "Jerarquico #2"
                ) !== undefined
                  ? "  /  "
                  : null}
                {
                  isSelectedAptoView?.values?.find(
                    (e: any) => e.hierarchicalLevel === "Jerarquico #1"
                  )?.value
                }
              </p>
              {isSelectedAptoView?.values
                ?.sort((a: any, b: any) => a.indice - b.indice)
                .map((e: any) => {
                  if (e.type !== "Hierarchical" && e.state_attribute) {
                    return (
                      <p>
                        {
                          attributes?.find((a: any) => a.id === e.attribute)
                            .name
                        }{" "}
                        <strong>
                          {e.value === "0 m²" || e.value === "0"
                            ? " N/A "
                            : e.value}
                        </strong>
                      </p>
                    );
                  }
                })}
            </div>

            <div className="inmueble-botones">
              {isSelectedAptoView?.galleries?.length > 0 &&
              isSelectedAptoView?.galleries?.filter(
                (g: any) => g.name !== "Vistadeinmuebles"
              )?.length > 0 ? (
                <button
                  className="btn-ver-galeria"
                  onClick={() => {
                    setGaleriaSelected(isSelectedAptoView?.galleries),
                      setSubMenuSelected("Galería"),
                      setOriginalGleriaSelected(isSelectedAptoView?.galleries);
                  }}
                >
                  Ver Galería
                </button>
              ) : null}
              {cotizacion ? (
                <button
                  className={`btn-cotizar${
                    selectedCotizacion?.length >= 5 ? "disabled" : ""
                  }`}
                  style={
                    selectedCotizacion?.find(
                      (e: any) =>
                        JSON.stringify(e) === JSON.stringify(isSelectedAptoView)
                    )
                      ? { color: "#FFF", backgroundColor: colors?.main_buttons }
                      : {}
                  }
                  onClick={() => {
                    if (
                      selectedCotizacion?.find(
                        (e: any) =>
                          JSON.stringify(e) ===
                          JSON.stringify(isSelectedAptoView)
                      )
                    ) {
                      // Si el objeto ya está en el array, lo eliminamos
                      setSelectedCotizacion((prev: any) =>
                        prev.filter(
                          (e: any) =>
                            JSON.stringify(e) !==
                            JSON.stringify(isSelectedAptoView)
                        )
                      );
                    } else {
                      // Si el objeto no está en el array y no está deshabilitado, lo agregamos
                      if (selectedCotizacion?.length < 5) {
                        setSelectedCotizacion((prev: any) => [
                          ...prev,
                          isSelectedAptoView,
                        ]);
                      }
                    }
                    setIsCotizacion(true);
                  }}
                >
                  Agregar a cotización
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className={`vista-inmuebles-container ${theme}`}>
      <div
        className={`vista-inmuebles-sidebar-mobile ${
          isMinimized ? "minimized" : "expanded"
        } ${isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"}`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="swipe-handle"></div>
        <div className="vista-inmuebles-sidebar-logo">
          <img
            src={
              version < "2.1.0"
                ? icono.icono
                : `${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net"
                  }${icono.icono}`
            }
            alt=""
          />
          <div className="vista-inmuebles-sidebar-title">COTIZACIÓN</div>
        </div>
        <div className="vista-inmuebles-sidebar-controle">
          {/* 🔽 Select personalizado de pisos */}
          <div className="dropdown">
            <select
              className="floor-select"
              value={currentFloor}
              onChange={(e) => {
                const selectedValue = parseInt(e.target.value);
                const piso = pisos?.values?.find(
                  (p: any) => parseInt(p.value) === selectedValue
                );
                if (piso) handleSelectFloor(piso);
              }}
            >
              {pisos?.values?.map((piso: any, index: number) => {
                const newFloor = parseInt(piso?.value);
                const floorDiff = newFloor - currentFloor;
                const newPropertyNumber =
                  parseInt(isSelectedAptoView?.property) + floorDiff * 100;

                const newProperty = properties?.find(
                  (item: any) => item.property === newPropertyNumber.toString()
                );

                const galleriesToCheck =
                  (Array.isArray(newProperty?.galleries) &&
                    newProperty.galleries) ||
                  (Array.isArray(isSelectedAptoView?.galleries) &&
                    isSelectedAptoView.galleries) ||
                  [];

                const hasVistaDeInmuebles = galleriesToCheck.some(
                  (gallery: any) => gallery?.type === "Vistadeinmuebles"
                );

                if (!hasVistaDeInmuebles) return null;

                return (
                  <option key={index} value={piso.value}>
                    Piso {piso.value}
                  </option>
                );
              })}
            </select>
          </div>

          {/* 🔼 Botones Subir / Bajar */}
          <div className="floor-buttons">
            {["Subir", "Bajar"].map((action, index) => {
              const currentFloor = parseInt(
                isSelectedAptoView?.values?.find(
                  (item: any) => item.type === "Piso/Nivel"
                )?.value
              );

              const newFloor =
                action === "Subir" ? currentFloor + 1 : currentFloor - 1;
              const floorDiff = newFloor - currentFloor;

              const newPropertyNumber =
                parseInt(isSelectedAptoView?.property) + floorDiff * 100;

              const newProperty = properties?.find(
                (item: any) => item.property === newPropertyNumber.toString() && item?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value === isSelectedAptoView?.values.find((v: any) => v.hierarchicalLevel === "Jerarquico #1")?.value
              );

              const handleClick = () => {
                if (!newProperty) return;

                const galleriesToCheck =
                  (Array.isArray(newProperty?.galleries) &&
                    newProperty.galleries) ||
                  (Array.isArray(isSelectedAptoView?.galleries) &&
                    isSelectedAptoView.galleries) ||
                  [];

                const hasVistaDeInmuebles = galleriesToCheck.some(
                  (gallery: any) => gallery?.type === "Vistadeinmuebles"
                );

                if (!hasVistaDeInmuebles) return;

                setIsSelectedApto({
                  ...newProperty,
                  verts: isSelectedAptoView.verts,
                });
                setIsSideBar({
                  ...newProperty,
                  verts: isSelectedAptoView.verts,
                });
              };

              return (
                <button
                  key={index}
                  className={`floor-btn ${
                    action === "Subir" ? "subir" : "bajar"
                  }`}
                  style={{ backgroundColor: colors?.main_buttons }}
                  onClick={handleClick}
                >
                  {action === "Subir" ? "▲ Subir" : "▼ Bajar"}
                </button>
              );
            })}
          </div>
        </div>
        <div className="vista-inmuebles-inmueble-header">
          <button
            className="arrow-btn"
            style={{ backgroundColor: colors?.main_buttons }}
            onClick={() => handleChangeProperty("prev")}
          >
            ←
          </button>

          <div className="inmueble-info">
            <div className="inmueble-title-container">
              <span className="inmueble-titulo">
                Inmueble <strong>{isSelectedAptoView?.property}</strong>
              </span>
              <span
                className="info-icon"
                onClick={() =>
                  setIsTooltipVistaInmueble(!isTooltipVistaInmueble)
                }
                style={{ backgroundColor: colors?.main_buttons }}
              >
                i
              </span>
            </div>
            <span className="inmueble-subtitulo">
              {
                isSelectedAptoView?.values?.find(
                  (e: any) => e.hierarchicalLevel === "Jerarquico #2"
                )?.value
              }
              {isSelectedAptoView?.values?.find(
                (e: any) => e.hierarchicalLevel === "Jerarquico #2"
              ) !== undefined
                ? "  /  "
                : null}
              {
                isSelectedAptoView?.values?.find(
                  (e: any) => e.hierarchicalLevel === "Jerarquico #1"
                )?.value
              }
            </span>
          </div>

          <button
            className="arrow-btn"
            style={{ backgroundColor: colors?.main_buttons }}
            onClick={() => handleChangeProperty("next")}
          >
            →
          </button>
        </div>
        <div className={`sidebar-container-portrait-close  ${theme}`}>
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(null);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
